import { render, staticRenderFns } from "./ResumeOrderDialog.vue?vue&type=template&id=0b212c1e&"
import script from "./ResumeOrderDialog.vue?vue&type=script&lang=js&"
export * from "./ResumeOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports